import React from 'react'
import Contact from '../components/Contact'

import MainPageLayout from '../components/MainPageLayout'

const ContactMe = () => {
  return (
    <MainPageLayout>
          <Contact />
    </MainPageLayout>
  )
}

export default ContactMe